// App.js
import React, { useState, useEffect } from 'react';
import FarmaciaList from './FarmaciaList';
import './App.css';

function App() {
  const [farmacias, setFarmacias] = useState([]);
  const [regionSeleccionada, setRegionSeleccionada] = useState('');

  useEffect(() => {
    obtenerFarmacias();
  }, []);

  const obtenerFarmacias = async () => {
    try {
      const response = await fetch('https://midas.minsal.cl/farmacia_v2/WS/getLocalesTurnos.php');
      const data = await response.json();
      setFarmacias(data);
    } catch (error) {
      console.error('Error al obtener las farmacias:', error);
    }
  };

  const handleRegionChange = (event) => {
    setRegionSeleccionada(event.target.value);
  };

  const regiones = [
    { nombre: 'Todas las regiones', valor: '' },
    { nombre: 'Arica y Parinacota', valor: '1' },
    { nombre: 'Tarapacá', valor: '2' },
    { nombre: 'Antofagasta', valor: '3' },
    { nombre: 'Atacama', valor: '4' },
    { nombre: 'Coquimbo', valor: '5' },
    { nombre: 'Valparaíso', valor: '6' },
    { nombre: 'Metropolitana de Santiago', valor: '7' },
    { nombre: 'Libertador General Bernardo O\'Higgins', valor: '8' },
    { nombre: 'Maule', valor: '9' },
    { nombre: 'Ñuble', valor: '16' },
    { nombre: 'Biobío', valor: '10' },
    { nombre: 'La Araucanía', valor: '11' },
    { nombre: 'Los Ríos', valor: '12' },
    { nombre: 'Los Lagos', valor: '13' },
    { nombre: 'Aysén del General Carlos Ibáñez del Campo', valor: '14' },
    { nombre: 'Magallanes y de la Antártica Chilena', valor: '15' }
  ];

  return (
    <div className="App">
      <h1>Farmacias de Turno</h1>
      <h3>Selecciona tu región para mostrar las farmacias de turno</h3>
      <select value={regionSeleccionada} onChange={handleRegionChange}>
        {regiones.map((region, index) => (
          <option key={index} value={region.valor}>{region.nombre}</option>
        ))}
      </select>
      <FarmaciaList farmacias={farmacias} regionSeleccionada={regionSeleccionada} />
    </div>
  );
}

export default App;
